module.exports = __webpack_public_path__ + "static/endeavour45-272ed323d1ea9191e1f426845206db34.mp4";